import React from "react";
import LargeHubLinkSection from "./LargeHubLinkSection";

const TutorialCards = () => {
  const sectionTitle = "Learn to code for analysis";
  const cardList = [
    {
      title: "SQL Tutorial",
      subTitle: "Pull, aggregate, filter, and join from databases.",
      buttonHref: "/sql-tutorial/",
    },
    {
      title: "Python Tutorial",
      subTitle: "Explore data visualization, modeling, and analysis.",
      buttonHref: "/python-tutorial/",
    }
  ];
  return (
    <LargeHubLinkSection sectionTitle={sectionTitle} cardList={cardList} />
  );
};

export default TutorialCards;
